import { render, staticRenderFns } from "./Blocos.vue?vue&type=template&id=5c219090"
import script from "./Blocos.vue?vue&type=script&lang=js"
export * from "./Blocos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports